import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cache_retry",
  "use": "cache_retry-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"cache_retry\"><path d=\"M5 18a5 5 0 0 1-.949-9.91C4.433 4.653 6.951 2 10 2c3.314 0 6 3.134 6 7 0 .34-.02.676-.061 1.004L16 10a4 4 0 1 1 0 8H5Z\" opacity=\".15\" /><path d=\"M6.464 13.536A5.002 5.002 0 0 0 14.9 11h-1.026a4.002 4.002 0 0 1-6.702 1.828L9 11H5v4l1.464-1.464ZM5.1 9a5.002 5.002 0 0 1 8.436-2.536L15 5l-.007 4H11l1.828-1.828A4.002 4.002 0 0 0 6.126 9H5.1Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol